<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/14oTqVg/tc-custom/9780253045027.jpg?1721453033389" alt="This image is the cover for the book Where Rivers and Mountains Sing"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Where Rivers and Mountains Sing
      </h1>
      <p class="bookDescription body article font2">
        <p>Theodore Levin takes readers on a journey through the rich sonic world of inner Asia, where the elemental energies of wind, water, and echo; the ubiquitous presence of birds and animals; and the legendary feats of heroes have inspired a remarkable art and technology of sound-making among nomadic pastoralists. As performers from Tuva and other parts of inner Asia have responded to the growing worldwide popularity of their music, Levin follows them to the West, detailing their efforts to nourish global connections while preserving the power and poignancy of their music traditions. </p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Theodore Levin, Valentina Süzükei
      </h2>
      
      <p class="authorDescription body article"><P>Theodore Levin is Professor of Music at Dartmouth College and author of <I>The Hundred Thousand Fools of God: Musical Travels in Central Asia (and Queens, New York) </I>(IUP, 1997).</P><P>Valentina Süzükei is Senior Academic Officer of the Tuvan Institute for Humanities Research in Kyzyl, Tuva. She is author of three books on Tuvan music, including <I>The Musical Culture of Tuva in the Twentieth Century</I> (in Russian).</P></p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Indiana University Press
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?7eaa6486